
import { formatIntl } from '@/utils/string'
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'BaseGraph',
  props: {
    datasets: {
      type: Array as PropType<Array<Record<string, string>>>,
      default: () => []
    },
    labels: {
      type: Array as PropType<string[]>,
      default: () => []
    },
    type: {
      type: String,
      default: 'line'
    },
    height: {
      type: Number,
      default: 280
    },
    colors: {
      type: Array as PropType<string[]>,
      default: () => ['robin-500']
    },
    xIsSeries: {
      type: Boolean,
      default: true
    },
    barOptions: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      chartType: '',
      selectedMetric: ''
    }
  },
  computed: {
    axisOptions(): Record<string, string | boolean> {
      return {
        xIsSeries: this.xIsSeries
      }
    },
    lineOptions(): Record<string, number | boolean> {
      return {
        regionFill: 1
      }
    },
    chartHeight(): number {
      return this.height
    }
  },
  created() {
    this.chartType = this.type
  },
  methods: {
    formatIntl
  }
})
